export const UPDATE_BRANCH_FILTER = 'UPDATE_BRANCH_FILTER'
export const UPDATE_BRANCH_TREE = 'UPDATE_BRANCH_TREE'
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'
export const UPDATE_STRUCTURE_SEARCH = 'UPDATE_STRUCTURE_SEARCH'
